import { Component, css, html, LitElement, property, TemplateResult } from '@rxdi/lit-html';

import { ReactRevealAnimation } from './react.css';
/**
 * @customElement react-reveal
 */
@Component({
  selector: 'react-reveal',
  style: css`
    ${ReactRevealAnimation}
    .container {
      animation-name: react-reveal;
      animation-duration: 700ms;
      animation-delay: 0ms;
    }
  `,
  template(this: ReactRevealComponent) {
    return html`${this.template}`;
  },
})
export class ReactRevealComponent extends LitElement {
  @property({ type: Object })
  private template: TemplateResult = html``;
  @property({ type: Number })
  delay = 300;
  OnUpdateFirst() {
    setTimeout(() => (this.template = html`<div class="container"><slot></slot></div>`), this.delay);
  }
}
